export enum Options {
	COUNTRY = 'COUNTRY',
	LANGUAGE = 'LANGUAGE',
	LISTRANGE = 'LISTRANGE',
	REGION = 'REGION',
	TIMEZONE = 'TIMEZONE'
}
